/* eslint-disable prettier/prettier */

/**
 * Text selection options
 * @ignore
 */
class TextSelectionOptions {
  constructor(app) {
    this._disabled = false;
    this.app = app;
  }

  /**
   * @type {boolean}
   */
  get disabled() {
    return this._disabled;
  }

  /**
   * @param {boolean} value
   */
  set disabled(val) {
    this._disabled = val;
    this.app.disableSelection(val);
  }
}

export { TextSelectionOptions };
